module.exports = __webpack_public_path__ + "static/content-01-15abc937a8bdc818629631c52b7f692e.jpg";